var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTwitter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 61,
    height: 61,
    viewBox: "0 0 61 61",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.0068 47C37.2144 47 44.4384 36.2267 44.4384 26.8842C44.4384 26.5782 44.4384 26.2736 44.4174 25.9703C45.8228 24.9695 47.0359 23.7303 48 22.3108C46.6894 22.8825 45.2992 23.2575 43.8756 23.4231C45.3746 22.5396 46.4966 21.1499 47.0326 19.5127C45.623 20.3362 44.0809 20.9166 42.4728 21.2288C40.2469 18.8985 36.71 18.3282 33.8454 19.8376C30.9807 21.347 29.5008 24.5607 30.2354 27.6767C24.4617 27.3918 19.0823 24.7068 15.436 20.2901C13.5301 23.5205 14.5036 27.6531 17.6592 29.7277C16.5164 29.6944 15.3986 29.3909 14.4 28.8428V28.9324C14.4009 32.2978 16.8105 35.1964 20.161 35.8628C19.1038 36.1467 17.9946 36.1882 16.9186 35.9841C17.8593 38.8641 20.5552 40.837 23.6274 40.8939C21.0846 42.8614 17.9435 43.9295 14.7094 43.9263C14.1381 43.9252 13.5673 43.8911 13 43.8243C16.2839 45.8991 20.1049 46.9996 24.0068 46.9945",
    fill: "#1DA1F2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitter);
export default __webpack_public_path__ + "static/media/twitter.caf5777428452649ef068b8e8cb1114b.svg";
export { ForwardRef as ReactComponent };